(() => {
  const revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;

  function observeReveals(root = document) {
    root.querySelectorAll('.rt-reveal:not(.is-visible)').forEach((element) => {
      if (revealObserver) revealObserver.observe(element);
      else element.classList.add('is-visible');
    });
  }

  class RtSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-rt-slide]')];
      this.dots = [...this.querySelectorAll('[data-rt-dot]')];
      this.index = 0;
      if (this.slides.length < 2) return;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      this.querySelector('[data-rt-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-rt-next]')?.addEventListener('click', () => this.go(this.index + 1, true));

      const speed = Number(this.dataset.speed || 0) * 1000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (speed > 0 && !reduceMotion && !window.Shopify?.designMode) {
        this.timer = setInterval(() => this.go(this.index + 1), speed);
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('focusin', () => this.pause());
      }

      this.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.indexOf(event.target.closest('[data-rt-slide]'));
        if (i > -1) this.go(i, true);
      });
    }

    disconnectedCallback() {
      this.pause();
    }

    pause() {
      clearInterval(this.timer);
      this.timer = null;
    }

    go(next, manual = false) {
      if (manual) this.pause();
      const count = this.slides.length;
      this.index = ((next % count) + count) % count;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    }
  }

  if (!customElements.get('rt-slider')) customElements.define('rt-slider', RtSlider);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeReveals());
  } else {
    observeReveals();
  }

  document.addEventListener('shopify:section:load', (event) => observeReveals(event.target));
})();
